'use strict';

const { hydrate } = require('@grpn/hydration');

const CouponsList = require('./coupons-list');

module.exports = hydrate('CouponsList', CouponsList);
